import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { LoginPage } from "./auth/LoginPage";
import { AdminLayout } from "./admin/AdminLayout";
import { AccountsPage } from "./admin/AccountsPage";
import { AllLicensesPage } from "./admin/AllLicensesPage";
import { AccountDetailPage } from "./admin/AccountDetailPage";
import { CreateAccountPage } from "./admin/CreateAccountPage";
import { AdminsPage } from "./admin/AdminsPage";
import { CustomerLayout } from "./customer/CustomerLayout";
import { MyLicensesPage } from "./customer/MyLicensesPage";
import { ReportsPage } from "./customer/Reports/ReportsPage";
import { DashboardPage } from "./customer/Reports/DashboardPage";

export default function App() {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Authenticated — route by role. /reports/:licenseId is shared so admins
  // can also drill into a customer's dashboard from AccountDetailPage.
  // Firestore rules enforce who can actually read the docs.
  return (
    <Routes>
      {/* Cross-role: full-screen dark dashboard. */}
      <Route path="/reports/:licenseId" element={<DashboardPage />} />

      {isAdmin ? (
        <>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AccountsPage />} />
            <Route path="/admin/licenses" element={<AllLicensesPage />} />
            <Route path="/admin/accounts/new" element={<CreateAccountPage />} />
            <Route path="/admin/accounts/:accountId" element={<AccountDetailPage />} />
            <Route path="/admin/admins" element={<AdminsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </>
      ) : (
        <>
          <Route element={<CustomerLayout />}>
            {/* Reports is the home page — owners want sales-at-a-glance, not the
                license-keys list. Licenses page is reachable from the nav. */}
            <Route path="/customer" element={<ReportsPage />} />
            <Route path="/customer/licenses" element={<MyLicensesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/customer" replace />} />
        </>
      )}
    </Routes>
  );
}
